import moment from 'moment'

const widgetFormats = ['MM/DD/YYYY', 'M/D/YYYY']

moment.updateLocale('en', {
  relativeTime: {
    dd: (number) => {
      const weeks = Math.round(number / 7)
      return number < 7
        ? `${number} days`
        : `${weeks} week${weeks > 1 ? 's' : ''}`
    }
  }
})

moment.relativeTimeThreshold('M', 24)
moment.relativeTimeThreshold('dd', 1)

export const widgetDateFormat = {
  renewal: (date) => (moment(date).isValid()
    ? moment(date, widgetFormats).format('MMMM YYYY')
    : ''
  ),
  due: (date) => (moment(date).isValid()
    ? moment(date).fromNow()
    : ''
  )
}
